import React, { useState } from 'react';
import classnames from 'classnames';
import { Col, Nav, NavItem, NavLink, Row } from 'reactstrap';

const TabsOptionsList = [
  { label: "Devices Log", key: 'device' },
  { label: "System Logs", key: 'system' },
  { label: 'OOBM Logs', key: 'oob' }
]

function NavLogBar(props) {
  const { selected, onTabChange, user } = props;

  // Filter tabs based on user role
  const filteredTabs = user?.role === 'admin' 
    ? TabsOptionsList.filter(option => option.key === 'oob')  // Admin only sees OOBM Logs
    : TabsOptionsList;

  return (
    <Row>
      <Col sm={12}>
        <Nav tabs>
          {filteredTabs.map((option, index) => (
            <NavLink
              className={classnames({ active: selected === option.key })}
              style={{ cursor: 'pointer' }}
              onClick={() => onTabChange(option.key)}
              key={index}
            >
              {option.label}
            </NavLink>
          ))
          }
        </Nav>
      </Col>
    </Row>
  );
}

export default NavLogBar;
